import React from 'react';
import GuestNav from './guest-nav';

const GuestShell = ({ activeTab, bookingCode, slug, children }) => (
  <div className="guestShell">
    {children}
    <GuestNav activeTab={activeTab} bookingCode={bookingCode} slug={slug} />
  </div>
);

export default GuestShell;
